import MembershipService from "./service/index.js";
import MembershipClient from "./client/index.js";
export default MembershipService;
export { MembershipClient };
export var defaultClient = new MembershipClient();
export var defaultService = new MembershipService({
  client: defaultClient
});